import auth from './auth.js'
import store from '../data/AppData'
import _ from 'underscore'
import axios from 'axios'

const IS_LOCAL = process.env.NODE_ENV !== 'production'
const APP_ROOT = IS_LOCAL ? 'http://localhost:9000/' : ''
const API_URL = IS_LOCAL ? APP_ROOT + 'api/' : 'api/'
const VERSION_URL = APP_ROOT + 'version'
const ACADEMY_MAPPING_URL = API_URL + 'mappings'
const ACTIVITY_LOG_URL = API_URL + 'logs'
const USER_LOOKUP_URL = API_URL + 'userlookup'
const EXT_COMP_REF_URL = API_URL + 'extCompRef/'

const academyActionURL = (acadid, action) => {
	let url = API_URL + 'academy/' + acadid
	if (action) url += '/' + action
	return url
}

const makeOptions = (timeout) => {
	return {
		headers: auth.getAuthHeader(),
		timeout: timeout
	}
}

const handleError = (error, handler) => {
	let msg = 'Data retrieval error detected.'
	if (error.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		console.log(error.response.data)
		console.log(error.response.status)
		console.log(error.response.headers)
	} else if (error.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		console.log(error.request)
	} else {
		// Something happened in setting up the request that triggered an Error
		console.log('Error', error.message)
	}

	if (handler) {
		msg += ' Attempting retry. '
		handler().then(() => {
			store.commit('clearDataError')
		})
	}
	store.commit('setDataError', msg)
	console.log(error.config)
}

const post = (url, data, action, reqAuth = true, timeout = 60000) => {
	let options = reqAuth ? makeOptions(timeout) : null

	return axios.post(url, data, options).then((response) => {
		if (action) {
			store.commit(action, response.data)
		}
		return response
	}).catch(handleError)
}

const get = (url, action, reqAuth = true, errfunc = () => {}, timeout = 60000) => {
	console.log('URL', url)
	let options = reqAuth ? makeOptions(timeout) : null

	return axios.get(url, options).then((response) => {
		store.commit(action, response.data)
		return response
	}).catch(handleError, errfunc)
}

const api = {
	// get
	getAcadList () {
		return get(ACADEMY_MAPPING_URL, 'addAcademy')
	},
	getAppVersion () {
		return get(VERSION_URL, 'setVersion', false)
	},
	getAcademyConfig (acadid) {
		return get(academyActionURL(acadid, 'config'), 'setAcademyConfig')
	},
	getLogEntries (offset, filter) {
		let url = ACTIVITY_LOG_URL + '/' + offset
		if (filter) { url += '?filter=' + filter }
		return get(url, 'addLogEntries')
	},
	getJobsList (acadid) {
		return get(academyActionURL(acadid, 'jobsWithoutSwap'), 'addJobsList', true, () => {
			// if we timeout/or error lets try again
			return api.getJobsList(acadid)
		})
	},
	getJobsPayList (acadid) {
		return get(academyActionURL(acadid, 'jobsWithSwap'), 'addJobsPayList', true, () => {
			// if we timeout/or error lets try again
			return api.getJobsPayList(acadid)
		})
	},
	getStatus (acadid) {
		return get(academyActionURL(acadid, 'status'), 'setStatus', true, () => {
			// if we timeout/or error lets try again
			return api.getStatus(acadid)
		})
	},
	sync (acadid) {
		return get(academyActionURL(acadid, 'sync'), 'syncStatus')
	},
	acadLookup (acadid) {
		return get(academyActionURL(acadid), 'setAcademyInfo')
	},
	getExtCompRef (ref) {
		let url = EXT_COMP_REF_URL + ref
		return get(url, 'setExtCompRef')
	},
	// posts
	setHRIDsync (acadid, action) {
		return post(academyActionURL(acadid, 'hridsync'), {
			action: action
		}, 'setAcademyConfig')
	},
	setASCsync (acadid, action) {
		return post(academyActionURL(acadid, 'ascsync'), {
			action: action
		}, 'setAcademyConfig')
	},
	setHRIDpush (acadid, action) {
		return post(academyActionURL(acadid, 'hridpush'), {
			action: action
		}, 'setAcademyConfig')
	},
	setDelayRemoval (acadid, action, days) {
		// gaurd rail for days
		if (action === true && !_.isNumber(days)) {
			days = 1
		}
		return post(academyActionURL(acadid, 'delaydays'), {
			action: action,
			days: days
		}, 'setAcademyConfig')
	},
	updateIgnores (acadid, ignores) {
		return post(academyActionURL(acadid, 'ignores'), {
			acadid: acadid,
			ignores: ignores
		}, 'setAcademyConfig')
	},
	setJobMappings (acadid, map) {
		return post(academyActionURL(acadid, 'jobmappings'), {
			acadid: acadid,
			swapJobs: map
		}, 'setAcademyConfig')
	},
	updatePayType (acadid, hourly) {
		return post(academyActionURL(acadid, 'paytype'), hourly, 'setAcademyConfig')
	},
	updateExcluded (acadid, excludeJobs) {
		return post(academyActionURL(acadid, 'exclude'), excludeJobs, 'setAcademyConfig')
	},
	removeMapping (acadid, mapping) {
		return post(academyActionURL(acadid, 'removemapping'), mapping, 'removeMapping')
	},
	removeAllMappings (acadid) {
		return post(academyActionURL(acadid, 'removeallmappings'), {}, 'removeAllMappings')
	},
	getUser (query) {
		return post(USER_LOOKUP_URL, {
			query: query
		}, 'lookup')
	},
	getUserMappings (acadid) {
		return post(academyActionURL(acadid, 'newusermappings'), {}, 'setUserMappings')
	},
	getHierarchyStore (extCompRef, storeId) {
		return post(API_URL + 'hierarchy/nodeLookup', {
			extCompRef: extCompRef,
			storeId: storeId
		}, 'setHierarchyStore')
	},
	getUserDetails (acadid, schooxid, hsids) {
		return post(academyActionURL(acadid, 'userlookup'), {
			userid: schooxid,
			hsids: hsids
		}, 'setUserDetails')
	},
	test () {
		return get('api/test', 'log')
	},
	delink (acadid, user) {
		return post(academyActionURL(acadid, 'delink'), user, 'log')
	},
	createNewMapping (data) {
		return post(academyActionURL(data.acadid, 'makemapping'), data, 'createNewMapping')
	},
	confirmMapping (acadid, mapping) {
		return post(academyActionURL(acadid, 'confirmMapping'), mapping, 'onMappingConfirm')
	},
	getMissMatchReport (acadid) {
		/* eslint-disable */
		return axios.post(API_URL + 'academy/' + acadid + '/mismatchedNames.csv', {}, {
			headers: auth.getAuthHeader(),
			timeout: 10000,
			responseType: 'blob'
		}).then((response) => {
			let result = document.createElement('a')
			result.href = window.URL.createObjectURL(response.data)
			result.download = 'mismatchedNames.csv'
			return result
		}).then((link) => { link.click() })
		/* eslint-enable */
	}
	// ,
	// _post (url, data, after) {
	// 	store.commit('syncing', data, after)
	// 	return Vue.http.post(url, data, {
	// 		headers: auth.getAuthHeader()
	// 	}).then((response) => {
	// 		store.commit(after, response.data)
	// 		store.commit('syncDone')
	// 	}, (response) => {
	// 		store.commit('syncDone', response)
	// 		console.error(response)
	// 	})
	// }
}

export default api



// WEBPACK FOOTER //
// ./src/services/api.js